if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      // NEW: Slides per view, default to 1
      this.slidesPerView =
        parseInt(this.dataset.slidesPerView, 10) > 1
          ? parseInt(this.dataset.slidesPerView, 10)
          : 1;

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      // 'fade' effect only if 1 slide is visible
      const useFade = this.slidesPerView === 1;
      const slideGap = this.slidesPerView > 1 ? 32 : 0;

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: this.slidesPerView,
        spaceBetween: slideGap,
        slidesPerGroup: 1,
        loop: true,
        effect: useFade ? "fade" : "slide",
        fadeEffect: useFade
          ? {
              crossFade: true,
            }
          : undefined,
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        // Responsive: 1 slide on mobile, N slides on desktop
        breakpoints: {
          0: { 
            slidesPerView: 1, 
            effect: "slide", 
            fadeEffect: undefined,
            spaceBetween: 0 
          },
          992: {
            slidesPerView: this.slidesPerView,
            effect: useFade ? "fade" : "slide",
            fadeEffect: useFade
              ? {
                  crossFade: true,
                }
              : undefined,
            spaceBetween: slideGap
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      if (this.slider) {
        this.slider.on("init", this.handleChange.bind(this));
        this.slider.on("slideChange", this.handleChange.bind(this));
        this.slider.init();
      }

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) =>
          this.onBlockSelect(e)
        );
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType =
        slides[activeIndex] && slides[activeIndex].dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      if (slideType === "video_slide") {
        const video =
          slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          const playPromise = video.play();
          if (this.lastVideo) this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        if (this.lastVideo) this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
